import axios from 'axios';
import {API_URL} from './KEYS'

export default axios.create({
    baseURL: API_URL
    //baseURL: "http://localhost:5000/api"
})